import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const eventMessageRoutes = [
  {
    path: "/settings/event-message",
    name: "EventMessageList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "eventMessage" */ "./components/List"),
  },
];
